import React from "react";

const LegalHeader = () => (
  <section className="w-full bg-light-4 py-12 px-6 text-center">
    <h1 className="text-title font-bold text-dark-1 mb-2">Mentions Légales — NextMaker</h1>
    <p className="text-light-1 text-sm">(Mise à jour le : [date])</p>
  </section>
);

export default LegalHeader;
